import { render, staticRenderFns } from "./OLoader.vue?vue&type=template&id=68590428&scoped=true"
import script from "./OLoader.vue?vue&type=script&lang=js"
export * from "./OLoader.vue?vue&type=script&lang=js"
import style0 from "./OLoader.vue?vue&type=style&index=0&id=68590428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68590428",
  null
  
)

export default component.exports